import { createSlice } from '@reduxjs/toolkit';

import { Http } from '../../Http';

const initialState = {
   token: null,
   isAuthenticated: false,
   user: { email: '', name: '' },
   company: {name: '', email:''},
   rememberMe: false,
   lastLoggedIn: '',
};

export const companyAuth = createSlice({
   name: 'companyAuth',
   initialState,

   reducers: {
      logIn: (state, action) => {
         const { payload } = action;

         Http.defaults.headers.common['Authorization'] = `Bearer ${payload.token}`;
         return {
            ...state,
            token: payload.token,
            user: payload.user,
            isAuthenticated: true,
            lastLoggedIn: new Date().toISOString(),
         };
      },

      mE: (state, action) => {
        const { payload } = action;

        return {
           ...state,
           user: payload.user,
        };
      },

      company: (state, action) => {
        const { payload } = action;

        return {
           ...state,
           company: payload.company,
        };
      },

      logOut: (state) => {
         Http.defaults.headers.common['Authorization'] = '';
         return {
            ...state,
            user: initialState.user,
            // company: initialState.company,
            token: initialState.token,
            isAuthenticated: initialState.isAuthenticated,
            lastLoggedIn: initialState.lastLoggedIn,
         };
      },

      checkAuth: (state) => {
         if (state.token && state.isAuthenticated) {
            Http.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
         }

         return state;
      },

      refreshToken: (state, action) => {
         const { payload } = action;
         if (payload) {
            Http.defaults.headers.common['Authorization'] = `Bearer ${payload}`;
         }
         return state;
      }
   },
});

export const { logIn, logOut, checkAuth, refreshToken, mE , company} = companyAuth.actions;

export default companyAuth.reducer;
